// removed by extract-text-webpack-plugin
module.exports = {"Input":"src-components-search----input-module---Input---1b17Y","Input--large":"src-components-search----input-module---Input--large---1aTPK","Input__control":"src-components-search----input-module---Input__control---1T0Is","Input--small":"src-components-search----input-module---Input--small---2R7ad","Input__icon":"src-components-search----input-module---Input__icon---1klbJ","Input__icon__img":"src-components-search----input-module---Input__icon__img---3rNxZ","spinAround":"src-components-search----input-module---spinAround---10QVz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/search/input.module.scss
// module id = 73
// module chunks = 114276838955818 131683993344931 142807904292071 184470312924441